import * as React from "react";

interface DelayedProps extends React.Props<Delayed> {
    children?: JSX.Element;
    delay?: number;
}

interface DelayedState {
    renderChildren: boolean;
}

export default class Delayed extends React.Component<DelayedProps, DelayedState> {

    private renderTimeout: number;

    constructor(props: DelayedProps) {
        super(props);
        this.state = {
            renderChildren: false
        };
    }

    render() {
        if (this.state.renderChildren) {
            return this.props.children;
        } else {
            return null;
        }
    }

    componentDidMount() {
        if (this.props.delay > 0) {
            this.renderTimeout = setTimeout(() => {
                this.setState({renderChildren: true});
            }, this.props.delay);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.renderTimeout);
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/components/Delayed.tsx
 **/